import { ZERO_DECIMAL_CURRENCIES } from '@aca-new/app/shared/constants/zero-decimal-currencies.constants';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CurrencyFormatService {
  public getFractionDigits(currencyCode: string | null | undefined): number {
    if (!currencyCode) {
      return 2;
    }

    return ZERO_DECIMAL_CURRENCIES.has(currencyCode.toUpperCase()) ? 0 : 2;
  }

  public formatAmount(value: number | string | null | undefined, currencyCode: string | null | undefined): string {
    const numericValue = typeof value === 'number' ? value : parseFloat(`${value ?? ''}`);

    if (isNaN(numericValue)) {
      return this._formatNumeric(0, this.getFractionDigits(currencyCode));
    }

    return this._formatNumeric(numericValue, this.getFractionDigits(currencyCode));
  }

  public formatWithCode(value: number | string | null | undefined, currencyCode: string | null | undefined): string {
    if (!currencyCode) {
      return this.formatAmount(value, currencyCode);
    }

    return `${currencyCode} ${this.formatAmount(value, currencyCode)}`;
  }

  private _formatNumeric(value: number, fractionDigits: number): string {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(value);
  }
}
